import { useQueries } from "@tanstack/react-query";
import { format } from "date-fns";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { viewWalletTransactions } from "src/api/wallet";
import CustomDataTable from "src/components/CustomDataTable";
import CustomDateRange from "src/components/CustomDateRange";
import WalletDetails from "src/components/WalletDetails";
import { renderCurrency } from "src/lib/utils";

const columns = [
	{ name: "Transaction Type", selector: (row) => (row.type === "DE" ? "Debit" : "Credit"), grow: 0.75 },
	{ name: "Amount", selector: (row) => renderCurrency(row.amount), grow: 0.75 },
	{ name: "Date", selector: (row) => format(row.created_at, "PPpp") },
	{ name: "Description", selector: (row) => row.description, grow: 1.5 },
];

const Wallet = () => {
	const [searchParams] = useSearchParams();
	const page = searchParams.get("page") || 1;
	const limit = searchParams.get("limit") || 10;
	const startDate = searchParams.get("start_date");
	const endDate = searchParams.get("end_date");

	const [{ data: rawWalletTransactions, isLoading }] = useQueries({
		queries: [
			{
				queryKey: ["wallet-transactions"],
				queryFn: () => viewWalletTransactions({ page, limit, startDate, endDate }),
			},
		],
	});

	const walletTransactions = rawWalletTransactions?.data?.data ?? [];
	const totalRow = rawWalletTransactions?.data?.total;

	return (
		<div className="tw-gap-6 tw-flex tw-flex-col">
			<WalletDetails />
			<div>
				<div className="tw-flex tw-items-center tw-justify-between tw-my-4">
					<p className="tw-font-semibold tw-text-lg">Wallet History</p>
					<CustomDateRange />
				</div>
				<CustomDataTable columns={columns} data={walletTransactions} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</div>
	);
};

export default Wallet;
